/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import RetryIcon from '@atlaskit/icon/glyph/retry';
import Tooltip from '@atlaskit/tooltip';
import messages from './messages';
export var RetryIconButton = function RetryIconButton(_ref) {
  var onClick = _ref.onClick,
    tabIndex = _ref.tabIndex,
    appearance = _ref.appearance,
    spacing = _ref.spacing;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var tooltip = formatMessage(messages.retryPrompt);
  return jsx(Tooltip, {
    content: tooltip,
    position: "top"
  }, jsx(IconButton, {
    testId: "retry-prompt-button",
    type: "button",
    onClick: onClick,
    icon: RetryIcon,
    label: tooltip,
    appearance: appearance,
    spacing: spacing,
    tabIndex: tabIndex
  }));
};